import React from 'react'
import MainHeadToAppend from './MainHeadToAppend'

function HeaderWithSearch() {
  return (
    <div className="MainTopButtonWrapper TopCornerButtonContainerScrolled">
    {/* <div className="TopMenuPanel" id="TopCornerButtonContainer">
        <div className="TopBackgroundThatWillChange"></div>
        <div className="TopMenuSectionWrapper" style={{ display: "flex" }} id="TopMenuMainWrapper">
        <a href="/"><img src="/Assets/images/Icon/pingingo-icon.svg" className="PinginGoLogo" /></a>
        <div className="MainTopSectionButtonWrapper BasicChildMargin" id="UserTopInfoWrapper">
            <div className="UserTopInfoWrapper" id="LanguageChangeTopMenu">
            <div className="UserTopProfileIcon"><img src="/Assets/images/CountryCode/Indonesia.svg" className="ImageFullCover" /></div>
            </div>
            <a className="BasicTextButton BasicBoxShadow ListinYourAccButton SignInButtonTop Selectable ListingMitraButtons">
            <div style={{ width: "fit-content", height: "fit-content", display: "flex", margin: "auto" }}>
                <img className="BasicIconInsideButton" style={{ marginLeft: 0 }} />
                <p id="ListYourAccBtnTxt" className="HideOnMobile" style={{ marginTop: "auto", marginBottom: "auto" }}>Listing your Accommodation</p>
                <p id="ListYourAccBtnTxtShort" className="ShowOnMobile" style={{ marginTop: "auto", marginBottom: "auto" }}>Join Now</p>
            </div>
            </a>
            <button className="BasicTextButton BasicBoxShadow OrangeButton2 SignInButtonTop Selectable" id="LoginInButtonTop" onClick={() => window.InstantiateLoginPanel('')}>Masuk</button>
            <button className="BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable" id="SignInButtonTop" onClick={() => window.InstantiateLoginPanel('')}>Register</button>
        </div>
        </div>
    </div> */}
    <MainHeadToAppend/>

    <div className="TopMenuPanel TopMenuPanelBlueGrad PaddingLeftRightForSafari">
        <div className="TopMenuSectionWrapper TopNonIndexSearchSection">
        <div className="HoverableContentInsideInputField CitySearchBarNonIndex Unselectable" id="InputFieldSearchContainer">
            <div className="SearchTopNonIndexSection BasicInputFieldContainer Selectable3" style={{ cursor: "text" }} onClick={() => document.getElementById('MainSearchInputField').focus()}>
                <img className="BasicIconInsideInput" src="/Assets/images/ButtonIcon/searchicon.svg" style={{ marginLeft: 0 }} />
                <div className="SearchInputFieldTopBottomTextWrapper">
                    <p className="BasicInputTextBottom InterRegularTextFont" id="MauNginepDimanaHeaderInputText">Mau Nginep Dimana?</p>
                    <input className="BasicInputTextTop InterBoldTextFont" placeholder="Bali" id="MainSearchInputField" defaultValue="" style={{ marginTop: 0 }} data-province-slug="" data-current-inputed="" />
                    <p className="BasicInputTextBottom InterRegularTextFont" style={{display:"none"}} id="TotalAccommodationText">-- Accommodations</p>
                </div>
            </div>
        </div>

        <div className="SearchTopRightSectionButtonWrapper" id='CheckInOutQuotaWrapper'>
            <div className="HoverableContentInsideInputField Unselectable" id="CheckInDateInput">
                <div className="SearchTopNonIndexSection BasicInputFieldContainer Selectable3">
                    <img className="BasicIconInsideInput" src="/Assets/images/ButtonIcon/check-in-out-icon.svg" style={{ marginLeft: "0" }} />
                    <div className="SearchInputFieldTopBottomTextWrapper">
                        <p className="BasicInputTextBottom InterRegularTextFont RoomUIDisplay" id="CheckInInputHeaderSearchText">Check-In</p>
                        <p className="BasicInputTextBottom InterRegularTextFont ExperienceUIDisplay" id="DateOfVisitSearchHeaderText" style={{display:"none"}}>Tanggal Berkunjung</p>
                        <p className="BasicInputTextTop InterBoldTextFont" id="CheckInDateInputDateText" style={{ marginTop: 0 }}>1 Jan 2000</p>
                        <p className="BasicInputTextBottom InterRegularTextFont" style={{display:"none"}} id="CheckInDateInputDayNameText">Saturday</p>
                    </div>
                </div>
            </div>

            <div className="HoverableContentInsideInputField Unselectable RoomUIDisplay" id="CheckOutDateInput">
                <div className="SearchTopNonIndexSection BasicInputFieldContainer Selectable3">
                    <img className="BasicIconInsideInput" src="/Assets/images/ButtonIcon/check-in-out-icon.svg" style={{ transform: "scaleX(-1)", marginLeft: 0 }} />
                    <div className="SearchInputFieldTopBottomTextWrapper">
                        <p className="BasicInputTextBottom InterRegularTextFont" id="CheckOutInputHeaderSearchText">Check-Out</p>
                        <p className="BasicInputTextTop InterBoldTextFont" id="CheckOutDateInputDateText" style={{ marginTop: 0 }}>02 Jan 2000</p>
                        <p className="BasicInputTextBottom InterRegularTextFont" style={{display:"none"}} id="CheckOutDateInputDayNameText">Sunday</p>
                    </div>
                </div>
            </div>

            <div className="HoverableContentInsideInputField Unselectable" id="RoomQuotaInput" data-room-quota="1">
            <div className="SearchTopNonIndexSection BasicInputFieldContainer Selectable3">
                <img className="BasicIconInsideInput ExperienceUIDisplay" src="/Assets/images/ButtonIcon/three-people-black.svg" style={{marginLeft: 0, display:"none"}} />
                <img className="BasicIconInsideInput RoomUIDisplay" src="/Assets/images/ButtonIcon/room-icon.svg" style={{marginLeft: 0}} />
                <div className="SearchInputFieldTopBottomTextWrapper">
                    <p className="BasicInputTextBottom InterRegularTextFont ExperienceUIDisplay" style={{display:"none"}} id="JumlahTamuHeaderSearch">Jumlah Tamu</p>
                    <p className="BasicInputTextBottom InterRegularTextFont RoomUIDisplay" id="HowManyNightText">1 Night</p>
                    <p className="BasicInputTextTop InterBoldTextFont" style={{ marginTop: 0 }} id="RoomQuotaTextDisplay">1 Room</p>
                </div>
                <img src="/Assets/images/ButtonIcon/chevron.svg" className="BasicInputFieldChevronIconSearch ToggleArrow" id="RoomQuotaToggleArrow" style={{ rotate: "0deg" }} />
            </div>
            </div>
        </div>

        <button className="BasicTextButton BasicBoxShadow OrangeButton SearchTopNonIndexButton Selectable" onClick={() => window.OnSearchTopButtonClicked()}>
            <img className="BasicIconInsideInput" src="/Assets/images/ButtonIcon/search-white.svg" style={{ marginLeft: "0" }} />
            <p className="InterMediumTextFont SearchButtonText">Search</p>
        </button>
        </div>
    </div>
    </div>
  )
}

export default HeaderWithSearch